import { render, staticRenderFns } from "./TradeReferences.vue?vue&type=template&id=411ef6b0"
import script from "./TradeReferences.vue?vue&type=script&lang=js"
export * from "./TradeReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports